import React, { FC, SVGProps, useEffect, useRef, useState } from "react";
import styled from "styled-components/macro";
import { TDefaultThemeNewColor } from "../../theme/defaultTheme";

interface IIconProps extends SVGProps<SVGSVGElement> {
  name: string;
  width?: number;
  className?: string;
  onClick?: (e?: any) => void;
  color?: TDefaultThemeNewColor;
}

export const Icon: FC<IIconProps> = (props): JSX.Element | null => {
  const { name, width, className, onClick, color } = props;
  const ImportedIconRef = useRef<FC<SVGProps<SVGSVGElement>>>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let isComponentMounted = true;
    setLoading(true);

    (async (): Promise<void> => {
      try {
        const { default: namedImport } = await import(
          `!!@svgr/webpack?-svgo,+titleProp,+ref!../../assets/icons/${name}.svg`
        );
        ImportedIconRef.current = namedImport;
      } catch (err) {
        // throw err;
      } finally {
        isComponentMounted && setLoading(false);
      }
    })();

    return () => {
      isComponentMounted = false;
    };
  }, [name]);

  if (loading || !ImportedIconRef.current) return null;

  const { current: ImportedIcon } = ImportedIconRef;

  return (
    <IconWrapper iconWidth={width} className={className} onClick={onClick} color={color}>
      <ImportedIcon />
    </IconWrapper>
  );
};

const IconWrapper = styled.div<{
  iconWidth?: number;
  onClick?: () => void;
  color?: TDefaultThemeNewColor;
}>`
  display: inline-block;
  cursor: ${({ onClick }) => (!!onClick ? "pointer" : "inherit")};

  > svg {
    ${({ iconWidth }) => iconWidth !== undefined && `width: ${iconWidth}px;`}
    height: 100%;
    display: block;
  }

  ${({ color, theme }) =>
    color &&
    `
      svg g {
        &, path, circle, rect {
          stroke: ${theme.newColors[color]} !important;
        }

        rect {
          fill: ${theme.newColors[color]} !important;
        }

        tspan {
          stroke: transparent !important;
          fill: ${theme.newColors[color]} !important;
        }
      }

      svg > path {
        stroke: ${theme.newColors[color]} !important;
      }
  `};
`;
